(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('inventoryActionCustomerReport', inventoryActionCustomerReport);

	inventoryActionCustomerReport.$inject = ['$scope', '$timeout', '$state', '$rootScope',
		'$stateParams', '$location', '$translate', '$experiments', 'FIRST_VIEW',
		'redirectParamsService', 'leanFilterService', 'currencyFormatService',
		'tableRenderService', 'tableService', 'storeService', 'flexColumns'
	];

	function inventoryActionCustomerReport($scope, $timeout, $state, $rootScope,
			$stateParams, $location, $translate, $experiments, FIRST_VIEW, redirectParamsService, leanFilterService, currencyFormatService,
			tableRenderService, tableService, storeService, flexColumns) {
		var vm = this;
		var unsubscribe;
		var currentState = $state.current;
		var pageType = currentState.url;
		var reportSettingsName = 'inventory-actions';

		// Apply stored redirect params before choosing React vs Angular path
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams()) {
			$location.search(redirectParamsService.popRedirectParams());
		}

		// §3.6 widget-drilldown guard — keep widget deep-links on Angular until React parity ships.
		// Only treat reportingPeriod/reportingPeriods as drilldown when drilldown=1 is set; they are also normal filter params.
		var urlParams = $location.search();
		var hasWidgetDrilldown = !!($stateParams.weekEndTimestamp
            || $stateParams.reportingPeriods
            || ($stateParams.filters && Object.keys($stateParams.filters).length > 0)
            || urlParams.drilldown === '1'
            || urlParams.drilldown === 1);

		vm.useReactReport = !hasWidgetDrilldown && $experiments.isEnabled('react-inventory-actions');
		vm.viewType = FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[reportSettingsName] || '';

		var mainColumn = {};
		var defaultFilters = [{
			'id': 'factory',
			'values': [globalConfig.factory.id],
			'isMandatory': true
		}, {
			'id': 'inventoryActionStatus',
			'values': [leanFilterService.leanDnaAllSelected],
			'isMandatory': true
		}, {
			'id': 'unableToFixCategoryNdx',
			'values': [leanFilterService.leanDnaAllSelected],
			'isMandatory': true
		}, {
			'id': 'buyerCode',
			'values': [leanFilterService.leanDnaAllSelected],
			'isMandatory': true
		}, {
			'id': 'supplierNdx',
			'values': [leanFilterService.leanDnaAllSelected],
			'isMandatory': true
		}];
		var pinnedColumns = [];

		// Extra query params to send to backend in data requests
		var extraParams = [{
			excelReportName: 'InventoryActionsReport'
		}];
		// Extra drilldown query params to parse
		var extraFilters = [];
		var translatedValue = {
			'Total Opportunity': $translate.instant('Total Opportunity'),
			'Potential Remaining': $translate.instant('Potential Remaining'),
			'Realized Value': $translate.instant('Realized Value'),
			'Expired Value': $translate.instant('Expired Value')
		};
		var rendererParams = {
			specificTaskType: 'action',
			defaultTab: 'opportunitiesSection'
		};

		vm.isSavedReport = false;
		vm.targetCurrency = undefined;
		vm.reportName = 'Inventory actions';
		vm.showExcel = true;

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;

		//Set correct navigation highlighting
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		$scope.filterService = leanFilterService;

		var meta = {
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			reportName: 'Inventory actions',
			reportUrl: '{0}/InventoryActionsReport',
			noPaging: false,
			columns: getColumns(),
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			defaultSort: 'potentialSavings',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			excelReportName: 'InventoryActionsReport',
			useReportBuilderForExcel: true,
			excelRequest: true,
			hasMandatoryFilters: true
		};

		var totals = null;

		init();
		widgetFilters();

		function init() {
			$scope.filterService.clearFilters();
			$scope.useFactoryFilter = true;
			leanFilterService.useFactoryFilter = true;
			var responsibleFilter = leanFilterService.filterDefinitions.Responsible;
			responsibleFilter.displayName = 'Responsible';
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.includeInFilter = true;
			siteFilter.removable = false;
			var filters = {};
			filters.rangeFilters = [
				$scope.filterService.filterDefinitions['TaskCount'],
				$scope.filterService.filterDefinitions['CompletedDate'],
				$scope.filterService.filterDefinitions['ActionCreationDate'],
				$scope.filterService.filterDefinitions['DueDate'],
				$scope.filterService.filterDefinitions['LastActivity']
			];
			var statusFilter = $scope.filterService.filterDefinitions['InventoryActionStatusOpenFixedWontExpired'];
			if ($rootScope.authz.isLeanDNAAdmin()) {
				statusFilter = $scope.filterService.filterDefinitions['InventoryActionStatusIncludeHidden'];
			}
			filters.multiSelectFilters = [
				$scope.filterService.filterDefinitions['InventoryActionType'],
				statusFilter,
				$scope.filterService.filterDefinitions['BusinessUnit'],
				$scope.filterService.filterDefinitions['Division'],
				$scope.filterService.filterDefinitions['Entity'],
				siteFilter,
				$scope.filterService.filterDefinitions['Buyer'],
				$scope.filterService.filterDefinitions['Planner'],
				responsibleFilter,
				$scope.filterService.filterDefinitions['Item Group'],
				$scope.filterService.filterDefinitions['Supplier'],
				$scope.filterService.filterDefinitions['TaskStatus'],
				$scope.filterService.filterDefinitions['TaskCategory'],
				$scope.filterService.filterDefinitions['ERP Order Policy'],
				$scope.filterService.filterDefinitions['UnableToFixCategory'],
				$scope.filterService.filterDefinitions['FixedCategory'],
				$scope.filterService.filterDefinitions['MaterialGroup'],
				$scope.filterService.filterDefinitions['MaterialType'],
				$scope.filterService.filterDefinitions['EndItem']
			];
			if ($rootScope.authz.isLeanDNAAdmin()) {
				filters.multiSelectFilters.push($scope.filterService.filterDefinitions['AssignToPlanner']);
			}
			filters.multiSelectFilters.push($scope.filterService.filterDefinitions['InventoryActionReportingPeriod']);
			filters = $scope.filterService.addFlexFiltersBySourceType(['item'], filters);
			$scope.filterService.setAllFilterLists(filters);
		}

		function getColumns() {
			var columns = [
				{
					'id': 'status',
					'display': 'Status',
					'renderer': tableRenderService.statusWithCircle,
					'width': 100,
					'editable': true
				}, {
					'id': 'siteName',
					'display': 'Site',
					'width': 120
				}, {
					'id': 'itemCode',
					'display': 'Item Code',
					'renderer': tableRenderService.itemCode,
					'width': 250,
					'extraColumns': ['itemNdx','itemDescription','leanDirFactoryNdx', 'itemType', 'actionId', 'fullItemCode']
				}, {
					'id': 'itemGroupName',
					'display': 'Item Group',
					'width': 150,
					'show': false
				}, {
					'id': 'buyerCode',
					'display': 'Buyer',
					'width': 120
				}, {
					'id': 'supplierName',
					'display': 'Supplier',
					'width': 120,
					'show': false
				}, {
					'id': 'planner',
					'display': 'Planner',
					'width': 120,
					'show': false
				}, {
					'id': 'iaTaskOwner',
					'display': 'Responsible',
					'renderer': tableRenderService.inlineTaskList,
					'width': 120,
					'idField': 'iaTaskOwnerNdx',
					'editable': true
				}, {
					'id': 'lastComment',
					'display': 'Task Last Comment',
					'show': false,
					'width': 120,
					'renderer': tableRenderService.inlineTaskComment,
					'disabled': vm.isSupplier,
					'editable': true
				}, {
					'id': 'lastCommenter',
					'display': 'Task Last Commenter',
					'show': false,
					'width': 120,
					'disabled': vm.isSupplier
				}, {
					'id': 'lastCommentDate',
					'display': 'Task Last Comment Date',
					'renderer': tableRenderService.dateRenderer,
					'convertTimeZone': true,
					'show': false,
					'width': 120,
					'disabled': vm.isSupplier
				}, {
					'id': 'actionTypeDisplay',
					'display': 'Action Type',
					'width': 120,
					'show': false
				}, {
					'id': 'unableToFixComment',
					'display': 'Unable to Fix Reason',
					'width': 100,
					'show': false
				}, {
					'id': 'totalOpportunity',
					'display': 'Total Opportunity',
					'width': 100,
					'renderer': tableRenderService.currency,
					'show': false
				}, {
					'id': 'potentialSavings',
					'display': 'Potential Remaining',
					'width': 100,
					'renderer': tableRenderService.currency,
					'sortDefaultReverse': true
				}, {
					'id': 'actualSavings',
					'display': 'Realized Value',
					'width': 100,
					'renderer': tableRenderService.inventoryActionSavingsInlineEdit
				}, {
					'id': 'expiredSavings',
					'display': 'Expired Value',
					'renderer': tableRenderService.currency,
					'width': 100
				}, {
					'id': 'actionDateCreated',
					'display': 'Created Date',
					'renderer': tableRenderService.dateRenderer,
					'width': 100,
					'convertTimeZone': true
				}, {
					'id': 'dateCompleted',
					'display': 'Completed Date',
					'renderer': tableRenderService.dateRenderer,
					'width': 100,
					'convertTimeZone': true,
					'sortDefaultReverse': true,
					'show': false
				}, {
					'id': 'lastActivityTimestamp',
					'display': 'Last Activity',
					'renderer': tableRenderService.relativeDate,
					'width': 100,
					'show': false,
					'sortDefaultReverse': true
				}, {
					'id': 'dueDate',
					'display': 'Due Date',
					'renderer': tableRenderService.inlineTaskDueDate,
					'width': 100,
					'convertTimeZone': true,
					'statusColumn': 'status',
					'statusForCheckingPastDue': 'Open',
					'editable': true
				}, {
					'id': 'unableToFixCategoryName',
					'display': 'Unable to Fix Category',
					'width': 120
				}, {
					id: 'materialType',
					display: 'Material Type',
					show: false,
					width: 80
				}, {
					id: 'materialGroup',
					display: 'Material Group',
					show: false,
					width: 80
				}, {
					id: 'reportingPeriod',
					display: 'Reporting Period',
					renderer: tableRenderService.reportingPeriodRenderer,
					show: false,
					width: 100
				}
			];
			columns = flexColumns.addFlexColumnsBySourceType(['item'], columns);

			if ($rootScope.authz.isLeanDNAAdmin()) {
				columns = columns.concat([
					{
						'id': 'fixReason',
						'display': 'Fixed Category',
						'width': 400,
						'show': false
					}, {
						'id': 'isReassign',
						'display': 'Reassign',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'isPotential',
						'display': 'Is Potential Action',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'isBlacklisted',
						'display': 'Item Is Excluded',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'hasNearTermShortage',
						'display': 'Item Has Near-Term Shortage',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'isLessThanMOQ',
						'display': 'Savings Less Than MOQ',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'isBelowMin',
						'display': 'Savings Below Min',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'isVolatile',
						'display': 'Demand Is Volatile',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'isVolatileNew',
						'display': 'Demand Is Volatile (new)',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'hasExtraRequirements',
						'display': 'Has Extra Reqs',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'hasConsignmentStock',
						'display': 'Has Consignment Stock',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'hasWorkTransfer',
						'display': 'Has Work Transfer',
						'renderer': tableRenderService.yesNo,
						'width': 100,
						'show': false
					}, {
						'id': 'taskSubject',
						'display': 'Task Subject',
						'extraColumns': ['recommendation'],
						'width': 200,
						'show': false,
						'sort': false
					}, {
						'id': 'taskDescription',
						'display': 'Task Description',
						'extraColumns': ['recommendation'],
						'width': 800,
						'show': false,
						'sort': false
					}]);
			}

			// set position and default values
			for (var i = 0; i < columns.length; i++) {
				var column = columns[i];

				column.position = i;

				if (column.show === undefined) {
					column.show = true;
				}
				if (column.sort === undefined) {
					column.sort = true;
				}
				if (column.enablePinning === undefined) {
					column.enablePinning = true;
				}
			}
			return columns;
		}

		function widgetFilters() {
			if ($stateParams.weekEndTimestamp || $stateParams.reportingPeriods) {
				var urlParams = $location.search();
				urlParams.drilldown = 1;
				urlParams.sort = 'potentialSavings';
				urlParams.sortDesc = '1';
				if ($stateParams.weekEndTimestamp) {
					var endDate = moment($stateParams.weekEndTimestamp);
					var startDate = moment($stateParams.weekStartTimestamp);
					urlParams.creationDateValueOne = $stateParams.weekStartTimestamp;
					urlParams.creationDateValueTwo = $stateParams.weekEndTimestamp;
					urlParams.creationDateComparator = 'btw';
				} else {
					urlParams.reportingPeriod = $stateParams.reportingPeriods;
				}
				for (var filterName in $stateParams.filters) {
					if ($stateParams.filters.hasOwnProperty(filterName)) {
						var selected = $stateParams.filters[filterName];
						if (_.isArray(selected) && selected.length > 0) {
							urlParams[filterName] = selected.join(',');
						} else if(selected && selected.length > 0) {
							urlParams[filterName] = selected;
						}
					}
				}
				$location.search(urlParams);
			}
		}

		$rootScope.$on('updateHeaders', function(event, incomingInfo) {
			if (incomingInfo.hasValidSavings) {
				totals.actualSavings += incomingInfo.actualSavings;
			} else {
				totals.actualSavings -= incomingInfo.actualSavings;
			}
			updateTotals();
		});

		function updateTotals() {
			var i;
			if (totals) {
				totals.potentialSavings = totals.potentialSavings ? totals.potentialSavings : 0;
				totals.actualSavings = totals.actualSavings ? totals.actualSavings : 0;
				for (i = 0; i < meta.columns.length; i++) {
					var currencyValue = '';
					switch (meta.columns[i]['id']) {
					case 'totalOpportunity':
						currencyValue = currencyFormatService.get(totals.originalPotentialSavings, vm.targetCurrency);
						meta.columns[i]['display'] = translatedValue['Total Opportunity'] + ': ' + currencyValue;
						break;
					case 'potentialSavings':
						currencyValue = currencyFormatService.get(totals.potentialSavings, vm.targetCurrency);
						meta.columns[i]['display'] = translatedValue['Potential Remaining'] + ': ' + currencyValue;
						break;
					case 'actualSavings':
						currencyValue = currencyFormatService.get(totals.actualSavings, vm.targetCurrency);
						meta.columns[i]['display'] = translatedValue['Realized Value'] + ': ' + currencyValue;
						break;
					case 'expiredSavings':
						currencyValue = currencyFormatService.get(totals.expiredSavings, vm.targetCurrency);
						meta.columns[i]['display'] = translatedValue['Expired Value'] + ': ' + currencyValue;
						break;
					}
				}

				for (i = 0; i < meta.pinnedColumns.length; i++) {
					switch (meta.pinnedColumns[i]['id']) {
					case 'totalOpportunity':
						meta.pinnedColumns[i]['display'] = translatedValue['Total Opportunity'] + ': ' +
								currencyFormatService.get(totals.originalPotentialSavings, vm.targetCurrency);
						break;
					case 'potentialSavings':
						meta.pinnedColumns[i]['display'] = translatedValue['Potential Remaining'] + ': ' +
								currencyFormatService.get(totals.potentialSavings, vm.targetCurrency);
						break;
					case 'actualSavings':
						meta.pinnedColumns[i]['display'] = translatedValue['Realized Value'] + ': ' +
								currencyFormatService.get(totals.actualSavings, vm.targetCurrency);
						break;
					case 'expiredSavings':
						meta.pinnedColumns[i]['display'] = translatedValue['Expired Value'] + ': ' +
								currencyFormatService.get(totals.expiredSavings, vm.targetCurrency);
						break;
					}
				}
			}
		}

		function extractTaskStrings(data) {
			for (var i = 0; i < data.length; i++) {
				var recommendation = JSON.parse(data[i].recommendation || '{}');
				data[i].taskSubject = recommendation.taskSubject;
				data[i].taskDescription = recommendation.taskDescription;
			}
		}

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = meta.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = meta.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}


		function getSite() {
			return $location.search()['site'];
		}

		function broadcastExcel() {
			var columns = getColumnsForPost();
			columns.push({id: 'dateFirstUnableToFix'});
			$rootScope.$broadcast('export-excel', { columns: columns, doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined });
		}

		function getMeta() {
			return meta;
		}

		function getColumnsForPost() {
			var columns = getColumns();
			columns.forEach(function(column) {
				if (column.extraColumns) {
					column.extraColumns.forEach(function(id) {
						columns.push({id:id});
					});
				}
			});
			return _.uniqBy(columns, 'id');
		}

		function getData(params, extraParams) {
			return tableService.postData(params, extraParams, getColumnsForPost()).then(function (response) {
				if (response && response[0] && response[0].targetCurrency) {
					vm.targetCurrency = response[0].targetCurrency;
				}
				if ($rootScope.authz.isLeanDNAAdmin()) {
					extractTaskStrings(response[0].data);
				}
				totals = response[1];
				updateTotals();
				return response;
			});
		}
	}
})();
